import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer } from 'preact-i18n';
import Markdown from 'preact-markdown';
import { route } from 'preact-router';

import localUtil from '../../lib/util';

import InstallationList from '../../components/installation/list';
import InspectionList from '../../components/inspection/list';
import ArticleList from '../../components/article/list';
import ArticleTickerList from '../../components/article/listTicker';
import NewsList from '../../components/news/list';
// import NewsListTicker from '../../components/news/listTicker';
import MediaList from '../../components/media/list';
import RaceList from '../../components/race/list';
import LoanList from '../../components/part/loanList';
import TimeTrackerList from '../../components/timetracker/list';

import Convention from '../../components/convention';
import ConventionCompact from '../../components/convention/listCompact';
import ProductList from '../../components/product/list';

@observer
class Frontpage extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sessionid: new Date().getTime(),
            view: util.get('frontpage.view') || 'homepage',
        };
        this.mainContainer = null;
    }

    toggleMenu = () => {
        const { showMenu } = this.state;
        this.setState({
            showMenu: !showMenu,
        });
    }

    async loadNews(props = this.props) {
		const { newsStore, userStore } = props.stores;
        const { user } = userStore;
        const { isAdmin, isRaceAdmin, isMediaWorker } = user;
        const isWorkingWithMedia = isAdmin || isRaceAdmin || isMediaWorker;

		const query = {
			tag: 'frontpage',
		};
		if (isAdmin) {
			query.showall = 1;
		}
		await newsStore.load({
            query,
            url: isWorkingWithMedia ? null : '/api/news/public/',
        });
	}

    async loadMedia(props = this.props) {
		const { mediaStore, userStore } = props.stores;
		await mediaStore.load({});
	}

    async loadRace(props = this.props) {
		const { raceStore, userStore } = props.stores;
		await raceStore.load({ addData: ['totalContestants'], query: {} });
	}

    async loadMyRaces(props = this.props) {
		const { raceStore, userStore } = props.stores;
		await raceStore.loadMyRaces({});
	}

    async loadLoans(props = this.props) {
		const { loanStore, userStore } = props.stores;
		await loanStore.load({ query: { onlyOpenLoans: 1 } });
	}

    async loadTimeTracker(props = this.props) {
		const { timeTrackerStore, userStore } = props.stores;
        await timeTrackerStore.load({ addData: [], query: { running: true } });
        this.loadTimeTrackerTimer = setTimeout(() => this.loadTimeTracker(props), 1000 * 60);
	}

    async loadProducts(props = this.props) {
        const { productStore, appState } = props.stores;
        const { currentCustomer = {} } = appState;
        await productStore.load({
            query: {
                customer: currentCustomer?.id,
                webshop: 1,
            },
            url: `/api/products/public`,
            addData: [],
        });
    }

    loadAll = (props = this.props) => {
        const { appState, installationStore, inspectionStore } = this.props.stores;
        const { opts = {} } = appState;

        installationStore.setRefreshPage(() => {
            this.loadAll();
        });
        if (opts.showInstallation) {
            installationStore.load();
        }
        if (opts.showInspections) {
            inspectionStore.load();
        }
        if (opts.showNews) {
            this.loadNews();
        }
        if (opts.showMedia) {
            this.loadMedia();
        }
        if (opts.showRace) {
            this.loadRace();
            this.loadMyRaces();
        }
        if (opts.showLoan) {
            this.loadLoans();
        }
        if (opts.showTimeTracker) {
            this.loadTimeTracker();
        }
        if (opts.showFrontpageShop) {
            this.loadProducts();
        }
    }

    addInstallation = () => {
		const { appState, installationStore } = this.props.stores;
		const { drawerHeightMedium } = appState;

        const { installation } = installationStore;

		appState.openDrawer('newInstallation', {
			height: drawerHeightMedium,
			installation,
            callback: this.closeAddInstallation,
            lookupArray: 'installations',
		}, 1);
	}

    closeAddInstallation = () => {
        const { appState } = this.props.stores;
        appState.closeDrawer();
        this.loadAll(this.props, false);
    }

    editInstallation = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const { drawerLevel = 1 } = this.props;
        const { id, md5 } = e.target.closest('.list-button').dataset;
		const { appState } = this.props.stores;
		const { drawerHeightMedium } = appState;
		appState.openDrawer('editInstallation', {
			height: drawerHeightMedium,
			id,
			lookupArray: 'parts',
		}, drawerLevel + 1);
	}

    viewLoan = (e) => {
        const { drawerLevel = 1 } = this.props;
        const { id } = e.target.closest('.box-line').dataset;
		const { appState, loanStore } = this.props.stores;
        const { loans } = loanStore;
        const loan = loans.find(e => e.id === parseInt(id, 10));

		const { drawerHeightMedium } = appState;
		appState.openDrawer('viewLoan', {
			height: drawerHeightMedium,
			id: loan.part,
            loanId: id,
		}, drawerLevel + 1);
    }

    viewMarketplace = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const { id, title } = e.target.closest('.box-line').dataset;
        route(`/marketplace/${id}`);
    }

    toggleView = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const { view } = e.target.closest('div').dataset;
        this.setState({ view });
        util.set('frontpage.view', view);
        const { appState } = this.props.stores;
        appState.appContainerScrollTop();
    }

    setClickOnLogo = () => {
        const { appState } = this.props.stores;
        appState.setClickOnLogo(() => {
            const { appState } = this.props.stores;
            appState.appContainerScrollTop();
            this.setState({ view: 'homepage' });
            util.set('frontpage.view', 'homepage');
        });
    }

    componentDidMount() {
        this.loadAll();
        this.setClickOnLogo();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.page !== this.props.page || nextProps.artid !== this.props.artid) {
            this.loadAll(nextProps);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.loadTimeTrackerTimer);
    }

    render() {
        const {
            page,
            artid,
            bib,
            showAnimations = true,
        } = this.props;
        const { sessionid, showMenu, raceTime, view } = this.state;
        const { appState, userStore, articleStore, installationStore, inspectionStore, loanStore, newsStore, mediaStore, raceStore, timeTrackerStore, productStore } = this.props.stores;
        const { mainView, subView, isDevelopment, path, opts = {} } = appState;
        const { currentCustomer = {} } = appState;

        const { user = {}, isAdmin, isMediaWorker, isTimeTracker, isTester, isVeterinary, isPremium } = userStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

		const { articles } = articleStore;
		const { newsList } = newsStore;
        const { medias } = mediaStore;
        const { races, myRaces } = raceStore;
        const { installations } = installationStore;
        const { inspections } = inspectionStore;
        const { loans } = loanStore;
        const { timeTrackers } = timeTrackerStore;
        const { products } = productStore;

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100 h-100' style='max-width: 960px; padding-top: 0px; padding-bottom: 150px;'>

                    <NewsList
                        classNames={'mt-1'}
                        key={`top-commercial`}
                        stores={this.props.stores}
                        hideEmpty={true}
                        limit={1}
                        tag={'top-commercial'}
                        skipUpdate={true}
                        showHeader={false}
                    />

                    {opts.showArticle ? <>
                        {(opts.showRace || opts.showShooting) ? <>
                            {view === 'homepage' ? <>
                                <ArticleList
                                    classNames={' pl-3'}
                                    key={`frontpage-articles-news`}
                                    stores={this.props.stores}
                                    articles={articles}
                                    hideEmpty={true}
                                    tickerList={true}
                                    skipUpdate={true}
                                    category={'news'}
                                    limit={25}
                                    offset={0}
                                    label={<Text id='article.list-news'>News</Text>}
                                    labelBackgroundClass={'bg-danger'}
                                    labelClass={'text-white'}
                                    buttonTop='10'
                                    buttonRight='10'
                                />

                                <ArticleTickerList
                                    classNames={''}
                                    key={`frontpage-articles-ticker`}
                                    stores={this.props.stores}
                                    hideEmpty={true}
                                    skipUpdate={true}
                                    category={'ticker'}
                                    limit={25}
                                    offset={0}
                                    buttonTop='5'
                                    buttonRight='10'
                                />

                                <Convention
                                    classNames={'mt-4'}
                                    stores={this.props.stores}
                                    todayOnly={true}
                                    title={<Text id='convention.conventions-today'>Conventions today</Text>}
                                />
                                <ConventionCompact
                                    classNames={'mt-4'}
                                    stores={this.props.stores}
                                    openRegistrations={true}
                                    title={<Text id='convention.conventions-open'>Conventions open for registration</Text>}
                                />
                            </> : <>
                                <Convention
                                    classNames={'mt-4'}
                                    stores={this.props.stores}
                                    showGlobalButton={true}
                                    todayOnly={true}
                                    title={<Text id='convention.conventions-today'>Conventions today</Text>}
                                />
                            </>}

                        </> : <>
                            <ArticleList
                                classNames={' pl-3'}
                                key={`frontpage-articles-news`}
                                stores={this.props.stores}
                                articles={articles}
                                hideEmpty={true}
                                tickerList={true}
                                skipUpdate={true}
                                category={'news'}
                                limit={25}
                                offset={0}
                                label={<Text id='article.list-news'>News</Text>}
                                labelBackgroundClass={'bg-danger'}
                                labelClass={'text-white'}
                                buttonTop='10'
                                buttonRight='10'
                            />

                            <ArticleTickerList
                                classNames={''}
                                key={`frontpage-articles-ticker`}
                                stores={this.props.stores}
                                hideEmpty={true}
                                skipUpdate={true}
                                category={'ticker'}
                                limit={25}
                                offset={0}
                                buttonTop='5'
                                buttonRight='10'
                            />

                            <Convention
                                classNames={'mt-4'}
                                stores={this.props.stores}
                                todayOnly={true}
                                title={<Text id='convention.conventions-today'>Conventions today</Text>}
                            />
                            <ConventionCompact
                                classNames={'mt-4'}
                                stores={this.props.stores}
                                openRegistrations={true}
                                title={<Text id='convention.conventions-open'>Conventions open for registration</Text>}
                            />
                        </>}

                        {(opts.showRace || opts.showShooting) ? <>
                            <div
					        	class='position-absolute rounded-pill w-75 d-flex flex-row justify-content-center align-items-center bg-orange text-white py-1'
        						style='
                                    z-index: 999999;
                                    bottom: 100px;
                                    left: 50%;
                                    transform: translateX(-50%);
                                    font-size: 0.9rem;
                                    line-height: 1.0rem;
                                    cursor: pointer;
                                    max-width: 300px;
                                    overflow: hidden;
                                '
    					    >
                                <div
                                    class={`flex-fill d-flex flex-column align-items-center ml-1 mr-1 mt-1 px-1 py-1`}
                                    style={`${view === 'homepage' ? 'border-bottom: 5px solid #ffffff' : ''}`}
                                    onClick={this.toggleView}
                                    data-view='homepage'
                                >
                                    <span style='font-size: 1.3rem;'>
                                        <i class='fa-duotone fa-house' />
                                    </span>
                                    <small><Text id='frontpage.homepage'>Homepage</Text></small>
                                </div>
                                <div
                                    class={`flex-fill d-flex flex-column align-items-center ml-1 mr-1 mt-1 px-1 py-1`}
                                    style={`${view === 'feed' ? 'border-bottom: 5px solid #ffffff' : ''}`}
                                    onClick={this.toggleView}
                                    data-view='feed'
                                >
                                    <span style='font-size: 1.3rem;'>
                                        <i class='fa-duotone fa-comments' />
                                    </span>
                                    <small><Text id='article.user-feed'>User Feed</Text></small>
                                </div>
                                <div
                                    class={`flex-fill d-flex flex-column align-items-center ml-1 mr-1 mt-1 px-1 py-1`}
                                    style={`${view === 'marketplace' ? 'border-bottom: 5px solid #ffffff' : ''}`}
                                    onClick={this.toggleView}
                                    data-view='marketplace'
                                >
                                    <span style='font-size: 1.3rem;'>
                                        <i class='fa-duotone fa-box-open-full' />
                                    </span>
                                    <small><Text id='article.marketplace'>Marketplace</Text></small>
                                </div>
                            </div>

                            {view === 'homepage' && <>
                                <ArticleList
                                    classNames={'mt-1'}
                                    key={`frontpage-articles`}
                                    stores={this.props.stores}
                                    articles={articles}
                                    hideEmpty={true}
                                    frontpageList={true}
                                    buttonTop='15'
                                    buttonRight='5'
                                />

                                <ArticleList
                                    classNames={'mt-1 pl-3'}
                                    key={`frontpage-articles-other`}
                                    stores={this.props.stores}
                                    articles={articles}
                                    hideEmpty={true}
                                    tickerList={true}
                                    skipUpdate={true}
                                    category={'other'}
                                    limit={25}
                                    offset={0}
                                    label={<Text id='article.list-other'>Other</Text>}
                                    labelBackgroundClass={'bg-dark'}
                                    labelClass={'text-white'}
                                    buttonTop='10'
                                    buttonRight='10'
                                />
                            </>}

                            {view === 'feed' && <>

                            </>}

                            {view === 'marketplace' && <>

                            </>}


                        </> : <>
                            <ArticleList
                                classNames={'mt-1'}
                                key={`frontpage-articles`}
                                stores={this.props.stores}
                                articles={articles}
                                hideEmpty={true}
                                frontpageList={true}
                                buttonTop='15'
                                buttonRight='5'
                            />

                            <ArticleList
                                classNames={'mt-1 pl-3'}
                                key={`frontpage-articles-other`}
                                stores={this.props.stores}
                                articles={articles}
                                hideEmpty={true}
                                tickerList={true}
                                skipUpdate={true}
                                category={'other'}
                                limit={25}
                                offset={0}
                                label={<Text id='article.list-other'>Other</Text>}
                                labelBackgroundClass={'bg-dark'}
                                labelClass={'text-white'}
                                buttonTop='10'
                                buttonRight='10'
                            />
                        </>}
                    </> : <></>}

                    {/* {opts.showNews ? <NewsList
                        classNames={articles?.length > 0 ? 'mt-5 position-relative' : 'position-relative'}
                        key={`frontpage-news`}
                        stores={this.props.stores}
                        newsList={newsList}
                        // tag='frontpage'
                        hideEmpty={true}
                    /> : <></>} */}

                    {opts.showTimeTracker ? <TimeTrackerList
                        stores={this.props.stores}
                        classNames={(newsList?.length > 0 || articles?.length > 0) ? 'mt-5' : ''}
                        timeTrackers={timeTrackers}
                        hideEmpty={true}
                    /> : <></>}

                    {opts.showDyrejournal ? <>
                        <div class='d-flex flex-row justify-content-center align-items-center mt-5'>
                            <button
                                type='button'
                                class='btn btn-primary rounded-pill'
                                onClick={() => route('/dyrejournal-sale/')}
                            >
                                <Text id='dyrejournal.open-dyrejournal'>Open dyrejournal</Text>
                            </button>
                        </div>
                    </> : <></>}

                    {opts.showFrontpageShop && currentCustomer?.id ? <>
                        {products?.length > 0 && <>
                            <div class='font-weight-lighter px-3 mt-5 box-header d-flex flex-row justify-content-between'>
                                <Text id='frontpage.shop'>Shop</Text>
                            </div>
                            <ProductList stores={this.props.stores} products={products} classNames='mt-0' />
                            <div class='w-100 d-flex justify-content-center'>
                                <a
                                    href={`/products/${currentCustomer?.id}`}
                                    type='button'
                                    class='btn btn-primary rounded-pill mt-3 mx-3 my-0'
                                >
                                    <i class='fa-duotone fa-shop' /> <Text id='shop.see-all-products'>See all products</Text>
                                </a>
                            </div>
                        </>}
                    </> : <></>}

                    {/* isPremium: {JSON.stringify(isPremium)} */}

                    {/* {opts.showMedia && isMediaWorker && <MediaList
                        stores={this.props.stores}
                        medias={medias}
                        classNames={newsList?.length > 0 || timeTrackers?.length > 0 ? 'mt-5' : ''}
                        hideEmpty={true}
                    >
                        <Text id='media.list-help'>This is all your incoming media. Ie. photos, videos, documents. Click to see the details.</Text>
                    </MediaList>} */}

                    {opts.showRace ? <>
                        {view === 'homepage' ? <>
                            <RaceList
                                title={<Text id='race.races-live-now'>Races live now</Text>}
                                stores={this.props.stores}
                                races={races.filter(r => {
                                    if (r.isCancelled) {
                                        return false;
                                    }
                                    const startDate = new Date(r.startDate);
                                    const endDate = new Date(r.endDate);
                                    const now = new Date();
                                    return startDate < now && endDate > now;
                                })}
                                classNames={articles?.length > 0 || newsList?.length > 0 || medias?.length > 0 || timeTrackers?.length > 0 ? 'mt-5' : ''}
                                hideEmpty={true}
                            >
                                <Text id='race.list-live-help'>All races live now. Click to see the details.</Text>
                            </RaceList>

                            <RaceList
                                stores={this.props.stores}
                                races={races.filter(r => {
                                    if (r.isCancelled) {
                                        return true;
                                    }
                                    const startDate = new Date(r.startDate);
                                    const endDate = new Date(r.endDate);
                                    const now = new Date();
                                    return !(startDate < now && endDate > now);
                                })}
                                classNames={articles?.length > 0 || newsList?.length > 0 || medias?.length > 0 || timeTrackers?.length > 0 ? 'mt-5' : ''}
                                hideEmpty={true}
                                myRaces={myRaces}
                            >
                                <Text id='race.list-help'>All upcoming races available. Click to see the details.</Text>
                            </RaceList>
                        </> : <></>}
                    </> : <>
                        <RaceList
                            title={<Text id='race.races-live-now'>Races live now</Text>}
                            stores={this.props.stores}
                            races={races.filter(r => {
                                if (r.isCancelled) {
                                    return false;
                                }
                                const startDate = new Date(r.startDate);
                                const endDate = new Date(r.endDate);
                                const now = new Date();
                                return startDate < now && endDate > now;
                            })}
                            classNames={articles?.length > 0 || newsList?.length > 0 || medias?.length > 0 || timeTrackers?.length > 0 ? 'mt-5' : ''}
                            hideEmpty={true}
                        >
                            <Text id='race.list-live-help'>All races live now. Click to see the details.</Text>
                        </RaceList>

                        <RaceList
                            stores={this.props.stores}
                            races={races.filter(r => {
                                if (r.isCancelled) {
                                    return true;
                                }
                                const startDate = new Date(r.startDate);
                                const endDate = new Date(r.endDate);
                                const now = new Date();
                                return !(startDate < now && endDate > now);
                            })}
                            classNames={articles?.length > 0 || newsList?.length > 0 || medias?.length > 0 || timeTrackers?.length > 0 ? 'mt-5' : ''}
                            hideEmpty={true}
                            myRaces={myRaces}
                        >
                            <Text id='race.list-help'>All upcoming races available. Click to see the details.</Text>
                        </RaceList>
                    </>}


                    {opts.showArticle ? <>

                        {(opts.showRace || opts.showShooting) && <>
                            {view === 'marketplace' && <>
                                <ArticleList
                                    classNames={'mt-5 h-100'}
                                    key={`frontpage-articles-marketplace`}
                                    stores={this.props.stores}
                                    hideEmpty={true}
                                    skipUpdate={true}
                                    tickerList={false}
                                    category={'marketplace'}
                                    showBylineHeader={true}
                                    showComments={true}
                                    showLikes={true}
                                    limit={25}
                                    frontpageList={true}
                                    buttonClass={'btn-success'}
                                    showHeader={true}
                                    inputTitle={<Text id='article.marketplace'>Marketplace</Text>}
                                    fullWidthOnly={true}
                                    showCreateor={true}
                                    showCreateButton={(opts.showRace || opts.showShooting)}
                                    createButtonText={<Text id='article.create-article-for-sale'>Add new item for sale</Text>}
                                    showFilterBox={false}
                                    showAuthor={true}
                                    skipView={false}
                                    maxHeight={'90vh'}
                                    tickerMaxHeight={''}
                                    tickerMinHeight={''}
                                    tickerImgHeight={'200px'}
                                    tickerImgRatio={'3 / 4'}
                                    width={'140px'}
                                    imageStyles={' '}
                                    showSoMeStyle={true}
                                    view={this.viewMarketplace}
                                    elInfo2={e => e.category === 'marketplace' ? <>
                                        {e.isSold && <>
                                            <span class='badge badge-pill badge-danger ml-2'>
                                                <i class='fa-duotone fa-tag' /> <Text id='article.sold'>Sold</Text>
                                            </span>
                                        </>}
                                        <span class='badge badge-pill badge-success ml-2'>
                                            Kr. {util.format(e.price, 2)}
                                        </span>
                                    </> : <></>}
                                    buttonTop='10'
                                    buttonRight='10'
                                    checkContentHeight={true}
                                />
                            </>}
                        </>}

                        {(opts.showRace || opts.showShooting) ? <>
                            {view === 'feed' && <>
                                <ArticleList
                                    classNames={'mt-5 h-100'}
                                    key={`frontpage-articles-feed`}
                                    stores={this.props.stores}
                                    hideEmpty={true}
                                    skipUpdate={true}
                                    category={'feed'}
                                    showBylineHeader={true}
                                    showComments={true}
                                    showLikes={true}
                                    showTitle={false}
                                    limit={25}
                                    frontpageList={true}
                                    buttonClass={'btn-success'}
                                    showHeader={true}
                                    inputTitle={<Text id='article.user-feed'>User Feed</Text>}
                                    fullWidthOnly={true}
                                    showCreateor={true}
                                    showCreateButton={(opts.showRace || opts.showShooting)}
                                    createButtonText={<Text id='article.create-article'>Add new post</Text>}
                                    showFilterBox={false}
                                    showAuthor={true}
                                    skipView={true}
                                    maxHeight={'90vh'}
                                    imageStyles={' '}
                                    buttonTop='10'
                                    buttonRight='5'
                                    checkContentHeight={true}
                                />
                            </>}
                        </> : <>
                            <ArticleList
                                classNames={'mt-5 h-100'}
                                key={`frontpage-articles-feed`}
                                stores={this.props.stores}
                                hideEmpty={true}
                                skipUpdate={true}
                                category={'feed'}
                                showBylineHeader={true}
                                showComments={true}
                                showLikes={true}
                                showTitle={false}
                                limit={25}
                                frontpageList={true}
                                buttonClass={'btn-success'}
                                showHeader={true}
                                inputTitle={<Text id='article.user-feed'>User Feed</Text>}
                                fullWidthOnly={true}
                                showCreateor={true}
                                showCreateButton={(opts.showRace || opts.showShooting)}
                                createButtonText={<Text id='article.create-article'>Add new post</Text>}
                                showFilterBox={false}
                                showAuthor={true}
                                skipView={true}
                                maxHeight={'90vh'}
                                imageStyles={' '}
                                buttonTop='10'
                                buttonRight='5'
                                checkContentHeight={true}
                            />
                        </>}
                    </> : <></>}

                    {opts.showInstallation ? <InstallationList
                        stores={this.props.stores}
                        installations={installations}
                        classNames={articles?.length > 0 || newsList?.length > 0 || medias?.length > 0 || races?.length > 0 || timeTrackers?.length > 0 ? 'mt-5' : ''}
                        addItem={opts.showAddInstallations ? this.addInstallation : null}
                        deleteElement={this.deleteInstallation}
                        editElement={this.editInstallation}
                    >
                        <Text id='installation.list-help'>This is all your installation or places where you keep your stuff. Ie. house, cabin, work, address.</Text>
                    </InstallationList> : <></>}

                    {opts.showLoan ? <>
                        <LoanList
                            stores={this.props.stores}
                            loans={loans}
                            classNames={'mt-5'}
                            hideEmpty={true}
                            view={this.viewLoan}
                        >
                            <Text id='loan.list-help'>This is all your parts currently loaned out to someone. Click to see the details.</Text>
                        </LoanList>
                    </> : <></>}

                    {opts.showInspections ? <>
                        <InspectionList
                            stores={this.props.stores}
                            inspections={inspections}
                            classNames={'mt-5'}
                            hideEmpty={true}
                        />
                    </> : <></>}

                    {opts.showNews ? <NewsList
                        classNames={'mt-5 position-relative'}
                        key={`latest-updates`}
                        stores={this.props.stores}
                        hideEmpty={true}
                        limit={5}
                        tag={'news'}
                        skipUpdate={true}
                        showHeader={true}
                        title={<Text id='news.list-last-updates'>Latest updates</Text>}
                    >
                        <Text id='news.list-last-updates-help'>This is the latest updates from the makers of the app.</Text>

                    </NewsList> : <></>}

                    {/* <SimpleBlog stores={this.props.stores} {...this.props} /> */}
                </div>
            </div>
        </>);
    }
}

export default Frontpage;
